import * as React from "react";
import { SVGProps, Ref, forwardRef } from "react";
const SvgAdministratorsIcon = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    {...props}
    width={24}
    height={24}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    ref={ref}
  >
    <path
      d="M20.995 6.9a.998.998 0 0 0-.548-.795l-8-4a1 1 0 0 0-.895 0l-8 4a1.002 1.002 0 0 0-.547.795c-.01.107-.96 10.767 8.59 15.014a.987.987 0 0 0 .811 0c9.55-4.247 8.6-14.906 8.59-15.014ZM12 19.897V12H5.51a15.473 15.473 0 0 1-.544-4.365L12 4.118V12h6.46c-.759 2.74-2.498 5.979-6.46 7.897Z"
      fill="currentColor"
    />
  </svg>
);
const ForwardRef = forwardRef(SvgAdministratorsIcon);
export default ForwardRef;
